import { getWebEnv } from "../env.js";

const env = getWebEnv();

export const GOOGLE_CLIENT_ID = env.googleClientId || "";
// who can access /console after sign-in
export const ALLOWED_ADMINS = [
  "lila@thebreakco.com",
  "mo@thebreakco.com",
  "fishintheseasemail@gmail.com",
  "info@home-ai.uk"
];
